import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
    FormControl,
    NgForm
} from '@angular/forms';
import { GestorService } from 'src/app/services/gestor.service';
import { Router, ActivatedRoute } from '@angular/router';
import { GestorCadastro } from 'src/app/models/gestor-cadastro';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { NgBrazilValidators, MASKS } from 'ng-brazil';
import { RegisterService } from 'src/app/services/register.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

import { CedenteGestorCadastro } from 'src/app/models/cedentegestor-cadastro';
import { IMyDpOptions } from 'mydatepicker';
import { IAngularMyDpOptions } from 'angular-mydatepicker';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-register-gestor',
    templateUrl: './register-gestor.component.html',
    styleUrls: ['./register-gestor.component.css']
})
export class RegisterGestorComponent implements OnInit {
    constructor(
        private formBuilder: FormBuilder,
        private gestorService: GestorService,
        private router: Router,
        private registerService: RegisterService,
        private route: ActivatedRoute,
        private alertService: NewAlertService
    ) {
        this.disableSince(new Date());
    }

    public get form() {
        return this.gestorCadastroFormGroup.controls;
    }

    public gestorCadastroFormGroup: FormGroup;
    private gestorCadastro: GestorCadastro;
    public inDocumento: string;

    public MASKS = MASKS;

    public myDatePickerOptions: IAngularMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        minYear: 1901,
        maxYear: 2078,
        monthLabels: {
            1: 'Janeiro',
            2: 'Fevereiro',
            3: 'Março',
            4: 'Abril',
            5: 'Maio',
            6: 'Junho',
            7: 'Julho',
            8: 'Agosto',
            9: 'Setembro',
            10: 'Outubro',
            11: 'Novembro',
            12: 'Dezembro'
        },
        dayLabels: {
            su: 'Dom',
            mo: 'Seg',
            tu: 'Ter',
            we: 'Qua',
            th: 'Qui',
            fr: 'Sex',
            sa: 'Sáb'
        },
        stylesData: {
            selector: 'dp1',
            styles: `
              .dp1 .myDpIconLeftArrow,
              .dp1 .myDpIconRightArrow,
              .dp1 .myDpHeaderBtn {
                 color: #6c757d;
              }
              .dp1 .myDpHeaderBtn:focus,
              .dp1 .myDpMonthLabel:focus,
              .dp1 .myDpYearLabel:focus {
                 color: #aaa;
              }
              .dp1 .myDpDaycell:focus,
              .dp1 .myDpMonthcell:focus,
              .dp1 .myDpYearcell:focus {
                 box-shadow: inset 0 0 0 1px #ccc;
              }
              .dp1 .myDpSelector:focus {
                 box-shadow: -1px 1px 6px 0px #bbb;
              }
              .dp1 .myDpSelectorArrow:focus:before {
                 border-bottom-color: #bbb;
              }
              .dp1 .myDpCurrMonth,
              .dp1 .myDpMonthcell,
              .dp1 .myDpYearcell {
                 color: #6c757d;
              }
              .dp1 .myDpDaycellWeekNbr {
                 color: #6c757d;
              }
              .dp1 .myDpPrevMonth,
              .dp1 .myDpNextMonth {
                 color: #aaa;
              }
              .dp1 .myDpWeekDayTitle {
                 background-color: transparent;
                 color: #6c757d;
              }
              .dp1 .myDpHeaderBtnEnabled:hover,
              .dp1 .myDpMonthLabel:hover,
              .dp1 .myDpYearLabel:hover {
                 color: #212529;
              }
              .dp1 .myDpMarkCurrDay,
              .dp1 .myDpMarkCurrMonth,
              .dp1 .myDpMarkCurrYear {
                 border-bottom: 2px solid #6c757d;
              }
              .dp1 .myDpDisabled {
                 color: #999;
              }
              .dp1 .myDpHighlight {
                 color: #cd5c5c;
              }
              .dp1 .myDpTableSingleDay:hover,
              .dp1 .myDpTableSingleMonth:hover,
              .dp1 .myDpTableSingleYear:hover {
                 background-color: #ccc;
                 color: #222;
              }
              .dp1 .myDpRangeColor {
                 background-color: #eee;
              }
              .dp1 .myDpSelectedDay,
              .dp1 .myDpSelectedMonth,
              .dp1 .myDpSelectedYear {
                 background-color: #ccc;
                 color: #222;
              }
            `
        }
    };
    dateMask = MaskedDate;

    disableSince(d: Date) {
        d.setDate(d.getDate() + 1);
        const copy = this.getCopyOfOptions();
        copy.disableSince = {
            year: d.getFullYear(),
            month: d.getMonth() + 1,
            day: d.getDate() - 1
        };
        this.myDatePickerOptions = copy;
        return this.myDatePickerOptions;
    }

    getCopyOfOptions() {
        return JSON.parse(JSON.stringify(this.myDatePickerOptions));
    }


    ngOnInit() {
        this.gestorCadastro = new GestorCadastro(
            '',
            '',
            '',
            null,
            '',
            '',
            '',
            '',
            null,
            ''
        );
        this.createForm(this.gestorCadastro);
    }

    createForm(gestorCadastro: GestorCadastro) {
        this.gestorCadastroFormGroup = this.formBuilder.group({
            companyName: new FormControl(gestorCadastro.companyName, [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(100)
            ]),
            numberOfEmployees: new FormControl('', [
                Validators.required,
            ]),
            nome: new FormControl(gestorCadastro.nome, [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            cpf: new FormControl(gestorCadastro.cpf, [
                Validators.required,
                NgBrazilValidators.cpf
            ]),
            telefoneNumero: new FormControl(gestorCadastro.telefoneNumero, [
                Validators.required,
                GenericValidator.isCellPhone,
                NgBrazilValidators.telefone
            ]),
            dataNascimento: new FormControl(gestorCadastro.dataNascimento, [
                Validators.required,
                GenericValidator.isAdult,
                GenericValidator.lockDate
            ]),
            email: new FormControl(gestorCadastro.email, [
                Validators.required,
                Validators.email
            ]),
            emailConfirmacao: new FormControl(gestorCadastro.emailConfirmacao, [
                Validators.required,
                Validators.email,
                GenericValidator.mustMatch('email')
            ]),
        });
    }

    public telefoneCelularMask = (telefone: any) => {
        telefone = telefone.replace(/\D+/g, '').replace(' ', '');
        if (telefone.length <= 10) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        } else if (telefone.length > 10) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        }
    }

    onSubmit(gestorCadastro: GestorCadastro) {
        let isNewPerson = false;
        const dataNascimentoMemoria = gestorCadastro.dataNascimento;

        if (gestorCadastro.dataNascimento) {
            if (gestorCadastro.dataNascimento.singleDate.date) {
                gestorCadastro.dataNascimento = new Date(
                    gestorCadastro.dataNascimento.singleDate.date.year,
                    gestorCadastro.dataNascimento.singleDate.date.month -
                    1,
                    gestorCadastro.dataNascimento.singleDate.date.day
                );
            }
        }

        if (this.gestorCadastroFormGroup.valid) {
            gestorCadastro.cpf = gestorCadastro.cpf
                .replace(/\D+/g, '')
                .replace(' ', '');
            gestorCadastro.telefoneNumero = gestorCadastro.telefoneNumero
                .replace(/\D+/g, '')
                .replace(' ', '');
            this.gestorService
                .validarCPF(gestorCadastro.cpf)
                .subscribe(response => {
                    // Verificação se a pessoa já existe no sistema
                    if (
                        response.status ===
                        ApiError.DocumentoValidoPessoaCorrentista ||
                        response.status ===
                        ApiError.DocumentoValidoPessoaExisteCadastro
                    ) {
                        // valido e existe
                        isNewPerson = false;
                    } else {
                        isNewPerson = true;
                    }

                    // Redirecionar
                    if (response.status !== ApiError.DadosInvalidos) {
                        this.registerService.changeCedenteGestorCadastro(
                            new CedenteGestorCadastro(
                                gestorCadastro,
                                null,
                                null
                            )
                        );

                        if (!isNewPerson) {
                            this.router.navigate(['gestor-confirm'], {
                                relativeTo: this.route.parent
                            });
                        } else {
                            this.router.navigate(['gestor-account'], {
                                relativeTo: this.route.parent
                            });
                        }
                    } else {
                        this.alertService.error(response.message);
                    }
                });
        }
    }

    public CompleteWithZero() {
        if (!this.inDocumento) { return; }

        const inputValue = this.inDocumento.replace(/\D+/g, '').replace(' ', '');
        let zeros = '';

        for (let i = 0; i < 11 - inputValue.length; i++) { zeros += '0'; }

        this.inDocumento = this.formataCPF(zeros + inputValue);
    }

    formataCPF(cpf) {
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
}

export function MaskedDate(event: any) {
    const v = event.target.value;
    if (event.keyCode !== 8) {
        if (v.match(/^\d{2}$/) !== null) {
            event.target.value = v + '/';
        } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
            event.target.value = v + '/';
        }
    }
}
